var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isAdmin || _vm.isClient || _vm.isVendor || _vm.isCarrier)?_c('asidec'):_vm._e(),_c('navc'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }